"use client";

import { Ico24ArrowRight } from "@/shared/assets/icons/ico_24_arrow_right";
import { Button } from "@/shared/ui/button";
import { gsap, useGSAP } from "@/shared/lib/gsap";
import { useRef } from "react";
import { useTranslations } from "next-intl";
import { useBreakpoint } from "@/shared/hooks/use-breakpoint";
import { useRouter } from "next/navigation";

export function PlanBanner() {
  const leftCircleRef = useRef<HTMLDivElement>(null);
  const rightCircleRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const t = useTranslations();
  const { isMobile, isTablet } = useBreakpoint();
  const router = useRouter();

  useGSAP(() => {
    if (!leftCircleRef.current || !rightCircleRef.current) return;

    // 두 원이 같은 중심점을 기준으로 원형 궤도로 회전 (관람차처럼)
    const centerX = 0; // 컨테이너 중심
    const centerY = 0;

    // 첫 번째 원 - 왼쪽 위치에서 시작
    gsap.to(leftCircleRef.current, {
      motionPath: {
        path: `M${centerX + 200},${centerY} A200,200 0 1,1 ${centerX - 200},${centerY} A200,200 0 1,1 ${centerX + 200},${centerY} Z`,
        autoRotate: false,
      },
      duration: 5,
      ease: "none",
      repeat: -1,
    });

    // 두 번째 원 - 오른쪽 위치에서 시작 (180도 차이)
    gsap.to(rightCircleRef.current, {
      motionPath: {
        path: `M${centerX - 200},${centerY} A200,200 0 1,1 ${centerX + 200},${centerY} A200,200 0 1,1 ${centerX - 200},${centerY} Z`,
        autoRotate: false,
      },
      duration: 5,
      ease: "none",
      repeat: -1,
    });
  });

  return (
    <div
      ref={containerRef}
      className="banner-gradient tb:h-109 pc:h-80 pc:py-16 tb:py-17.5 relative flex h-[309px] w-full items-center justify-center overflow-hidden py-8"
    >
      {/* 블러 원형 모션 */}
      <div
        ref={leftCircleRef}
        className="pointer-events-none absolute bottom-[-383px] left-[16.67vw] h-[469px] w-[756px] shrink-0 rounded-full bg-[#18F3C4] blur-[200px]"
      />

      <div
        ref={rightCircleRef}
        className="pointer-events-none absolute top-[78px] right-[-168px] h-[409px] w-[660px] shrink-0 rounded-full bg-[#0F53E3] blur-[200px]"
      />

      {isMobile || isTablet ? (
        <div className="tb:gap-8 relative z-10 flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-[10px] text-center">
            <h2 className="heading-2 whitespace-pre-line text-white">
              <span>{t("mn_cbn_tex_1_1")}</span>
              <br />
              <span className="text-primary-300">{t("mn_cbn_tex_1_2")}</span>
            </h2>

            <div className="h-[50px] w-px bg-white/60" />

            <div className="text-white">
              <span className="body-xl-regular">{t("mn_cbn_tex_2_1")} </span>
              <span className="body-xl-bold">{t("mn_cbn_tex_2_2")}</span>
            </div>
          </div>

          <Button variant="white_line" size="lg" className="w-fit" onClick={() => router.push("/inquiry")}>
            {t("mn_cbn_btn")} <Ico24ArrowRight className="size-6" />
          </Button>
        </div>
      ) : (
        <div className="relative z-10 flex items-center gap-[130px]">
          <div className="flex flex-col gap-8">
            <h2 className="heading-2 whitespace-pre-line text-white">
              <span>{t("mn_cbn_tex_1_1")}</span>
              <br />
              <span className="text-primary-300">{t("mn_cbn_tex_1_2")}</span>
            </h2>
            <Button variant="white_line" size="lg" className="w-fit" onClick={() => router.push("/inquiry")}>
              {t("mn_cbn_btn")} <Ico24ArrowRight className="size-6" />
            </Button>
          </div>

          <div className="h-px w-[298px] bg-white/60" />

          <div className="flex flex-col text-white">
            <span className="body-xl-regular">{t("mn_cbn_tex_2_1")}</span>
            <span className="body-xl-bold">{t("mn_cbn_tex_2_2")}</span>
          </div>
        </div>
      )}
    </div>
  );
}
